export class accordion {
    constructor(selector, el) {
        this.selector = selector;
        this.el = el;
        this.panelHeight = null;
        this.boundTrigger = null;
        this.isActive = false;

        this.trigger = this.el.querySelector(this.selector + "__trigger");
        this.panel = this.el.querySelector(this.selector + "__panel");

        this.el && this.trigger && this.panel && this.init();
    }

    init() {
        this.boundTrigger = this.handleClick.bind(this);
        this.panelHeight = this.panel.firstElementChild.clientHeight;

        this.isActive = this.panel.getAttribute("aria-hidden") === "false" ? true : false;

        this.trigger.addEventListener("click", this.boundTrigger);

        document.addEventListener("resizing", () => this.calcHeight());

        this.calcHeight();
    }

    handleClick() {
        this.isActive = !this.isActive;
        this.trigger.setAttribute("aria-expanded", `${this.isActive}`);
        this.panel.setAttribute("aria-hidden", `${!this.isActive}`);
        this.calcHeight();
    }

    calcHeight() {
        this.panel.style.setProperty("--height", this.panel.firstElementChild.clientHeight);
    }

    destroy() {
        this.trigger.removeEventListener("click", this.boundTrigger);
        document.removeEventListener("resizing", () => this.calcHeight());
    }
}
const accordions = selector => {
    const accordions = document.querySelectorAll(selector);
    accordions && accordions.forEach(data => new accordion(selector, data));
};

export default accordions;
